import React from "react";
import "../App.css";
import "./Account.css";
import like from "../assets/thumbsup2.png";
import profile1 from "../assets/StoryImage.jpg";
import comment from "../assets/commentBox2.png";
import { Component } from "react/cjs/react.development";
import { Link } from 'react-router-dom'

 
  export default class Story extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        likeCount: 0,
        commentCount: 0,
        artPath: "",
        blocked: false
      }
      // console.log("LOOK HERE", props.followerList);
      this.componentDidMount();
    }

 componentDidMount(){
  this.getLikeCount(this.props.post.id);
  this.getCommentCount();
  this.loadArt();
  this.checkUserConn();
  // console.log(this.props);
}

checkUserConn(){
    //Checks if user profile is blocked or not by currently signed in user
    fetch(process.env.REACT_APP_API_PATH + "/connections?fromUserID=" + sessionStorage.getItem('user') + "&toUserID=" + this.props.post.author.id, {
      method: "get",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      }
    })
    .then(res => res.json())
    .then(
      result => {
        if (result[1] > 0) {
          if (result[0][0].attributes.type === "blocking") {
            this.setState({
              blocked: true
            })
          }
        }else {
          if (this.props.post.attributes.storyPrivacy === "Private" && this.props.post.authorID != sessionStorage.getItem("user")) {
            // console.log("POST AUTHOR != LOGGED IN USER HERE _-------------------");
            // console.log(this.post.authorID != sessionStorage.getItem("user"));
            this.setState({
              blocked: true
            })
          }
        }
      }
    )
}

 async getLikeCount(thisPostID){
  const likeCountResponse = await fetch(process.env.REACT_APP_API_PATH+"/post-reactions?postID="+thisPostID+"&name=like", {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + sessionStorage.getItem("token")
    }
    });

  const apilikeCount = await likeCountResponse.json();

  this.setState({
    likeCount: apilikeCount[1]
  });
}

getCommentCount() {
  var count = this.props.post._count["children"]
  this.setState({
    commentCount: count
  })
}

async loadArt(){
  const artResponse = await fetch(process.env.REACT_APP_API_PATH+"/file-uploads", {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + sessionStorage.getItem("token")
    }
    });

    const artObject = await artResponse.json();
    // console.log("ART OBJECT");
    // console.log(artObject);
    var postID = this.props.post.id;
    // console.log("Post ID: " + this.props.post.id)
    var artwork = artObject[0].filter(art => (
      art.attributes.postID == postID
    ))
    // console.log("ARTWORK");
    // console.log(artwork);
    // console.log("ARTWORK LENGTH IS : " + artwork.length);
    if(artwork.length > 0){
      this.setState({
        artPath: "https://webdev.cse.buffalo.edu" + artwork[0].path
      })
      // console.log("ART PATH EXISTS!!!!!!!!");
    }
    else {
      this.setState({
        artPath: this.props.post.author.attributes.pfp
      })
      // console.log("ART PATH DEFAULT!!!!!!!");
    }

    // console.log("Art Path --> " + this.state.artPath);
}

// -------------------------------
// CSS IS AT BOTTOM OF ACCOUNT.CSS
// -------------------------------

  render(){
    return(
        <div className='accountStory'>
            <img alt={!this.state.blocked ? this.props.post.author.attributes.username : "blocked user"} src={!this.state.blocked ? this.state.artPath : '/diddy.gif'} height='100px' width='100px' className='storyPic'/>

            <Link className="storyName" to={`/post/${this.props.post.id}`}>
              <div className="storyName">{!this.state.blocked ? this.props.post.attributes["title"] : "Blocker User Title"}</div>
            </Link>

            <div className="profile-button-container">
              <div className="profile-like-container">
                <img src={like}
                alt="like icon"
                height='21'
                width='22'
                className="storyButton"
                />
                <p className="likeCounter">{!this.state.blocked ? this.state.likeCount : "X"}</p>
              </div>
              <div className="profile-comment-container">
                <img src={comment}
                alt="comment icon"
                  height= '21'
                  width='22'
                  className='commentBox'
                  />

                  <p className="commentCounter">{!this.state.blocked ? this.state.commentCount : "X"}</p>
              </div>
            </div>
        </div>

            
    );
  }
}

